module.exports = __webpack_public_path__ + "static/media/trash-green.57583850.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/trash-green.svg
// module id = 3271
// module chunks = 0